import React, { useState } from 'react'
import httpRequest from '../../services/http-request.js'

const Login = (props) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleUsernameChange = (event) => {
    setUsername(event.target.value)
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const response = await httpRequest('/api/appusers/auth/login', 'POST', {
        mobile: username,
        password,
      })
      const result = response.data.result
      const token = response.headers.get('Authorization')
      console.log(result)
      if (result && result.role && token) {
        localStorage.setItem('role', result.role)
        localStorage.setItem('token', token)
        localStorage.setItem('userName', result.firstname)
        props.navigate('/pl-report-by-market')
      }
    } catch (error) {
      console.log(error)
    }
    console.log(username, password)
  }

  return (
    <>
      <div className="login-container">
        <div className="login">
          <form onSubmit={handleSubmit}>
            <label>
              Enter Username:
              <input
                type="text"
                value={username}
                onChange={handleUsernameChange}
              />
            </label>
            <label>
              Enter Password:
              <input
                type="password"
                value={password}
                onChange={handlePasswordChange}
              />
            </label>
            <input type="submit" value="LOGIN" />
          </form>
        </div>
      </div>
    </>
  )
}

export default Login
